import assetPath from '/app/packages/lebenslauf/articles/src/assets/cagdas-aygun.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')